import React from 'react';

import type { fnGetFilteredProductLinks } from '@atlassian/global-shortcuts';

import { GlobalAppShortcuts } from './GlobalAppShortcutsWrapper.tsx';

export type GlobalAppShortcutsSectionProps = {
	orderedMenuConfig: { menuId: string; visible: boolean }[];
	onUpdateGetFilteredProductLinks: (fn: fnGetFilteredProductLinks) => void;
	isInvitedAppShortcutsEnabled: boolean;
};

export const GlobalAppShortcutsSection = ({
	orderedMenuConfig,
	onUpdateGetFilteredProductLinks,
	isInvitedAppShortcutsEnabled,
}: GlobalAppShortcutsSectionProps) => (
	<GlobalAppShortcuts
		orderedMenuConfig={orderedMenuConfig}
		onUpdateGetFilteredProductLinks={onUpdateGetFilteredProductLinks}
		isInvitedAppShortcutsEnabled={isInvitedAppShortcutsEnabled}
	/>
);
